import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getGgr = (params) => {
    return axios.get(`${backendHost}/api/admin/ggr/view`, {params});
};

export {
    getGgr
}